export default __webpack_public_path__ + "static/media/ZOOM_IN.384beeb1.svg";